import React from 'react';
import { GooglePlayBadgePNG, AppStoreBadgePNG } from '@yme/assets/images';
import { ImageButton } from '@yme/atoms/button';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, RegularTextLevel3, HeadingLevel4 } from '@yme/tokens/typography';
import { onOpenWindow } from '@yme/utils/common';
import { CustomFlexWrapper } from './styled';
export function PreviewContent(props) {
    const { title, subtitle, description, googlePlayLink, appStoreLink, labels, isRightToLeft } = props;
    if (!title && !subtitle && !description) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadingLevel4, { color: colorCoreBlack300 }, subtitle),
        React.createElement(FlexWrapper, { alignSelf: "start", mb: "24px", mbTablet: "16px" },
            React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, title)),
        React.createElement(FlexWrapper, { alignSelf: "start" },
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300, weight: 400 }, description)),
        React.createElement(CustomFlexWrapper, { alignSelf: "start", mt: "32px", mtTablet: "24px", gap: "8px", isRightToLeft: isRightToLeft },
            appStoreLink && AppStoreBadgePNG && (React.createElement(ImageButton, { width: "135px", height: "46px", onClick: () => onOpenWindow(appStoreLink) },
                React.createElement("img", { src: `${AppStoreBadgePNG}`, alt: labels.appSection_appStoreButton_altText, title: labels.appSection_appStoreButton_altText, width: "135px", height: "46px" }))),
            googlePlayLink && GooglePlayBadgePNG && (React.createElement(ImageButton, { width: "155px", height: "46px", onClick: () => onOpenWindow(googlePlayLink) },
                React.createElement("img", { src: `${GooglePlayBadgePNG}`, alt: labels.appSection_googlePlayButton_altText, title: labels.appSection_googlePlayButton_altText, width: "155px", height: "46px" }))))));
}
PreviewContent.displayName = 'PreviewContent_Component';
